import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import Head from 'next/head'
import { useRouter } from 'next/router'
import { siteConfig } from '@/constants/site'

const toAbsoluteUrl = (path: string): string => {
    if (/^https?:\/\//.test(path)) return path

    return `${siteConfig.url}${path.startsWith('/') ? path : `/${path}`}`
}

export const Seo: FC<SeoProps> = ({
    title,
    description = siteConfig.description,
    ogImage = siteConfig.ogImage
}): ReactNode => {
    const { pathname } = useRouter()
    const pageTitle = title ? `${title} - ${siteConfig.name}` : siteConfig.name
    const pageUrl = pathname === '/' ? siteConfig.url : toAbsoluteUrl(pathname)
    const imageUrl = ogImage ? toAbsoluteUrl(ogImage) : null

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={description} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={description} />
            <meta property='og:type' content='website' />
            <meta property='og:url' content={pageUrl} />
            <meta property='og:site_name' content={siteConfig.name} />
            <meta property='og:locale' content='en_US' />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={description} />

            {imageUrl && <meta property='og:image' content={imageUrl} />}
            {imageUrl && <meta name='twitter:image' content={imageUrl} />}
        </Head>
    )
}
